module.exports = __webpack_public_path__ + "img/6.5dd4e5d7.png";